export default "__VITE_ASSET__C6mB336$__"